import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../hooks/reduxHooks";
import { Col, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { TEAM_LOGO_URL } from "../../lib/globals";
import Select from "react-select";
import { ITournament } from "../../types/api";
import { store } from "../..";
import { tournamentManagementActions } from "../../features/tourneymgmt/tournamentManagementSlice";

export const loader = async () => {
    const tournaments = store.getState().tournamentmanagement.tournaments;
    const masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;

    const tournamentsPromise = tournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getTournaments());

    const masterTournamentsPromise = masterTournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getMasterTournaments());

    await Promise.all([tournamentsPromise, masterTournamentsPromise]);

    return null;
};

const TeamsByTournament = (): React.JSX.Element => {
    const { tournaments, masterTournaments } = useAppSelector(
        state => state.tournamentmanagement,
    );
    const [selectedMaster, setSelectedMaster] = useState<number>();
    const [childTournaments, setChildTournaments] = useState<ITournament[]>([]);

    useEffect(() => {
        setChildTournaments(
            tournaments.filter(t => t.parent === selectedMaster),
        );
    }, [selectedMaster]);

    return (
        <>
            <Row>
                <Col md={{ span: 8, offset: 2 }}>
                    <Select
                        isSearchable={true}
                        defaultValue={undefined}
                        isClearable={true}
                        placeholder="Select Master Tournament..."
                        options={masterTournaments.map(t => {
                            return {
                                value: parseInt(t.id.toString()),
                                label: t.name,
                            };
                        })}
                        onChange={v => setSelectedMaster(v?.value)}
                    />
                </Col>
            </Row>
            {childTournaments.length ? (
                childTournaments.map(t => (
                    <Table
                        className="teamsByTournament"
                        striped
                        bordered
                        key={t.id}
                    >
                        <thead>
                            <tr>
                                <th colSpan={7}>
                                    <h3>{`${t.ageLevel} - ${masterTournaments.find(t => t.id === selectedMaster)?.name}`}</h3>
                                </th>
                            </tr>
                            <tr>
                                <th>Team Logo</th>
                                <th>Team</th>
                                <th>Coach</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Roster</th>
                                <th>COI</th>
                            </tr>
                        </thead>
                        <tbody>
                            {t.teams?.map(team => (
                                <tr key={team.id}>
                                    <td>
                                        {team.logo && (
                                            <img
                                                src={`${TEAM_LOGO_URL}${team.logo}`}
                                                alt={`${team.name} logo`}
                                                className="teamLogo img-fluid"
                                            />
                                        )}
                                    </td>
                                    <td>
                                        <Link
                                            to={`/coachs-clubhouse/team/${team.id}`}
                                        >
                                            <h5 className="teamLink">
                                                {team.name}
                                            </h5>
                                        </Link>
                                    </td>
                                    <td>
                                        {`${team?.coach?.firstName} ${team?.coach?.lastName}`}
                                    </td>
                                    <td>
                                        <a
                                            href={`mailto:${team?.coach?.email}`}
                                        >
                                            {team?.coach?.email}
                                        </a>
                                    </td>
                                    <td>{team?.coach?.phone}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ))
            ) : (
                <></>
            )}
        </>
    );
};

export default TeamsByTournament;
